
import ManageUsers from "../components/admin/ManageUsers";

export default function AdminUsers() {
  return (
    <div>
      <ManageUsers />
    </div>
  );
}
